import React, { useState, useEffect, useCallback } from 'react';
import PercentCircle from '~/components/layout/PercentCircle';
import PercentBox from './styles';
import { useDispatch } from 'react-redux';

const OrderCycle = ({ status, statusFromApi, occupationStatus }) => {

  const dispatch = useDispatch();

  const [percent, setPercent] = useState(0);
  const [title, setTitle] = useState(null);
  const [step, setStep] = useState(null);
  const [next, setNext] = useState(null);
  const [alterStatus, setAlterStatus] = useState(status);
  const [cancel, setCancel] = useState(false);

  const handleStates = useCallback(
    (percent, title, step, alterStatus, next, cancel) => {
      if (percent) setPercent(percent);
      if (title) setTitle(title);
      if (step) setStep(step);
      if (alterStatus) setAlterStatus(alterStatus);
      if (next) setNext(next);
      if (cancel) setCancel(cancel);
    },
  );

  const handleOrderCycle = useCallback(() => {

    switch (status.toLowerCase()) {
      case 'em análise pelo financeiro':
        {
          handleStates(50, 'Financeiro', '2', status, 'Faturamento', false);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        }
        break;
      case 'pedido recebido aguardando análise': 
        {
          handleStates(25, 'Pedido', '1', status, 'Financeiro', false);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '1',
              titleStatus: 'Pedido',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        }
        break;
      case 'aguardando aprovação da logística':
        {
          handleStates(25, 'Pedido', '1', status, 'Financeiro', false);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '1',
              titleStatus: 'Pedido',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        }
        break;
      case 'não liberado pelo financeiro':
        {
          handleStates(50, 'Financeiro', '2', status, null, true);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;
      case 'pedido com restrição':
        {
          handleStates(50, 'Financeiro', '2', status, null, true);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;
      case 'pedido liberado pelo financeiro':
        if (!occupationStatus) {
          handleStates(50, 'Financeiro', '2', status, 'Faturamento', false);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '2',
              titleStatus: 'Financeiro',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (occupationStatus && occupationStatus.toLowerCase() === 'nota fiscal liberada') {
          handleStates(
            75,
            'Liberação',
            '4',
            'NOTA FISCAL LIBERADA',
            'Saída',
            false,
          );
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '4',
              titleStatus: 'Liberação',
              status: 'NOTA FISCAL LIBERADA',
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (
          occupationStatus && occupationStatus.toLowerCase() === 'saida do veículo realizada'
        ) {
          handleStates(
            100,
            'Saída',
            '5',
            'SAÍDA DO VEÍCULO REALIZADA',
            null,
            false,
          );
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '5',
              titleStatus: 'Saída',
              status: 'SAÍDA DO VEÍCULO REALIZADA',
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (occupationStatus && occupationStatus.toLowerCase() === 'aguardando emissão de nota fiscal' ||
                   occupationStatus && occupationStatus.toLowerCase() === 'aguardando faturamento') {
          handleStates(
            50,
            'Faturamento',
            '3',
            occupationStatus,
            'Liberação',
            false,
          );
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '3',
              titleStatus: 'Faturamento',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: false
            }
          })
        } else if (occupationStatus && occupationStatus.toLowerCase() === 'caminhão com restrição') {
          handleStates(
            50,
            'Faturamento',
            '3',
            occupationStatus,
            null,
            true,
          );
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '3',
              titleStatus: 'Faturamento',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;
      case 'pedido cancelado':
        {
          handleStates(25, 'Pedido', '1', status, null, true);
          dispatch({
            type: "SET_STATUSORDER",
            order: {
              step: '1',
              titleStatus: 'Pedido',
              status: status,
              occupationStatus: occupationStatus,
              statusFromApi: statusFromApi,
              cancel: true
            }
          })
        }
        break;

      default: {
        handleStates(0, null, null, status, null, null);
      }
    }
  });

  useEffect(() => {
    handleOrderCycle();
  }, [handleOrderCycle]);

  return (
    <PercentBox>
      <PercentCircle cancel={cancel} percent={percent} step={step} style={{ paddingTop: 1 }} />
      <PercentBox.PercentText>
        <div className="title-percent">{title}</div>
        <div className="status-percent">
          <span>{alterStatus}</span>
        </div>
        {next && <div className="next-percent">Próximo: {next}</div>}
      </PercentBox.PercentText>
    </PercentBox>
  );
};

export default OrderCycle;
